import Tooltip from '../Tooltip';

interface IMediaProps {
  media: string;
  mediaAltText?: string;
  displayExtendedMedia: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  showExtendedMedia: boolean;
}

const OptionMedia = ({
  media,
  mediaAltText = '',
  displayExtendedMedia,
  showExtendedMedia,
}: IMediaProps) => {
  if (!media) return null;
  const handleImageClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    displayExtendedMedia(event);
  };

  return (
    <Tooltip title="Click to Expand">
      <div
        className="bp-group bp-relative bp-ml-auto bp-max-h-12 bp-max-w-12 bp-shrink-0 bp-cursor-pointer bp-bg-white"
        onClick={handleImageClick}
      >
        {media.split('.').pop() === 'mp4' ? (
          <video className={`bp-h-full bp-w-full`} autoPlay muted loop>
            <source src={media} type="video/mp4" />
          </video>
        ) : (
          <img src={media} alt={mediaAltText} className={`bp-h-full bp-w-full`} />
        )}
      </div>
    </Tooltip>
  );
};

export default OptionMedia;
